/* ZOFF homepage behaviour -- ported from ZOFF_Homepage_finalV2.html (30 Sep 2026), loaded (defer) by
   layout/zoff.liquid only. Each block below is one section and returns early if its section is not on
   the page, so sections can be removed or reordered in the theme editor freely.

   DELIBERATE CHANGE FROM THE DESIGN FILE: its `prefers-reduced-motion` switches are gone (here and in
   zoff-home.css). With that OS setting on -- as it is on the machine this site is reviewed on -- the
   design file itself shows no animation at all, and "the animation doesn't work" is the report that
   follows. The motion is part of the brief.

   The cart, drawers and search live in assets/zoff-ui.js (window.ZH).

   SPEED PASS (26 Oct 2026, PageSpeed 61 mobile / 70 desktop):
   - hero: the loop clones are rendered by sections/zh-hero.liquid (no DOM insert = no layout shift);
     autoplay starts only after load + first interaction (or 6s), so the first slide stays the LCP;
     the other banners are decoded then, not at load
   - shop by dish: built only when it nears the viewport; the auto-scroll frame loop runs only while visible;
     its images are no longer forced to load eagerly
   - bestsellers: write every card first, then read heights once (one reflow, not one per card)
   - CSS animations of sections that are off screen are paused (zh-anim-off) */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; };
  var inView = function (el, threshold, fn) {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    new IntersectionObserver(function (en, obs) { en.forEach(function (e) { if (e.isIntersecting) { fn(); obs.disconnect(); } }); }, { threshold: threshold }).observe(el);
  };
  /* runs fn once the page has loaded and the visitor first interacts, or `wait` ms after load, whichever comes first */
  var afterSettle = function (fn, wait) {
    var done = false, evs = ['pointerdown', 'keydown', 'wheel', 'touchstart', 'scroll'];
    var go = function () { if (done) return; done = true; evs.forEach(function (ev) { window.removeEventListener(ev, go, true); }); fn(); };
    var arm = function () { evs.forEach(function (ev) { window.addEventListener(ev, go, { capture: true, passive: true, once: true }); }); setTimeout(go, wait); };
    if (document.readyState === 'complete') arm(); else window.addEventListener('load', arm, { once: true });
  };

  /* the header ticker and USP marquee are held (layout/theme.liquid) until the page settles */
  afterSettle(function () { document.documentElement.classList.add('zh-go'); }, 6000);

  /* pause the CSS animations of every homepage section while it is off screen (marquees, motes, rails) */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var st = document.createElement('style');
    /* 2 Nov 2026: html:not(#z1):not(#z2) so the pause also beats ID rules with their own !important animation (the Natasha arrow ran forever off screen) */
    var P = 'html:not(#z1):not(#z2) .zh-anim-off';
    st.textContent = P + ',' + P + ' *,' + P + ' *::before,' + P + ' *::after{animation-play-state:paused!important}';
    document.head.appendChild(st);
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { e.target.classList.toggle('zh-anim-off', !e.isIntersecting); }); }, { rootMargin: '150px 0px' });
    $$('#page-sections > .shopify-section').forEach(function (s) { io.observe(s); });
  })();

  /* ── Hero: sliding carousel (9 Oct 2026) — auto-advance, seamless loop, drag/swipe, arrows, keyboard;
        pauses on hover, focus, hidden tab and while off screen; header takes the banner colour ── */
  (function () {
    var hero = document.getElementById('hero'); if (!hero) return;
    var track = $('[data-hero-track]', hero), viewport = track && track.parentNode;
    var slides = $$('[data-hero-slide]', hero); if (!slides.length || !track) return;
    var n = slides.length;
    var desk = window.matchMedia('(min-width: 700px)');
    var canHover = window.matchMedia('(hover: hover)');
    var meta = $('meta[name="theme-color"]');
    var colour = function (i) { var s = slides[i]; return (desk.matches ? s.getAttribute('data-bg-desktop') : s.getAttribute('data-bg-mobile')) || '#53cafd'; };
    var num = $('[data-hero-num]', hero), live = $('[data-hero-live]', hero), bar = $('[data-hero-progress]', hero);
    var dur = (parseFloat(hero.getAttribute('data-autoplay')) || 0) * 1000;
    var active = 0, pos = 1;

    /* a copy of the last slide before the first and of the first after the last, so the loop never jumps backwards */
    if (n > 1 && $('[data-hero-clone]', track)) {
      /* clones already rendered by the section (26 Oct 2026) */
    } else if (n > 1) {
      var clone = function (s) {
        var c = s.cloneNode(true);
        c.removeAttribute('data-hero-slide'); c.removeAttribute('data-shopify-editor-block'); c.removeAttribute('id');
        c.setAttribute('aria-hidden', 'true'); c.tabIndex = -1;
        $$('img', c).forEach(function (i) { i.removeAttribute('fetchpriority'); });
        return c;
      };
      track.insertBefore(clone(slides[n - 1]), slides[0]);
      track.appendChild(clone(slides[0]));
    } else { pos = 0; }

    function place(animate) {
      track.style.transition = animate ? '' : 'none';
      track.style.transform = 'translate3d(' + (-pos * 100) + '%,0,0)';
      if (!animate) { void track.offsetWidth; track.style.transition = ''; }
    }
    function fitHeight() { var h = slides[active].offsetHeight; if (h) viewport.style.height = h + 'px'; }
    function mark(announce) {
      slides.forEach(function (s, i) {
        var on = i === active;
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.tabIndex = on ? 0 : -1;
      });
      document.documentElement.style.setProperty('--hero-bg', colour(active));
      hero.setAttribute('data-active-slide', String(active));
      if (meta) meta.content = colour(active);
      if (num) num.textContent = String(active + 1).padStart(2, '0');
      if (announce && live) live.textContent = 'Slide ' + (active + 1) + ' of ' + n + ': ' + (slides[active].getAttribute('data-name') || '');
      fitHeight();
    }
    function normalise() {
      if (n < 2) return;
      if (pos <= 0) { pos = n; place(false); }
      else if (pos >= n + 1) { pos = 1; place(false); }
    }
    function go(step, announce) {
      if (n < 2) return;
      normalise();
      var moveFocus = slides[active].contains(document.activeElement);
      pos += step;
      active = ((pos - 1) % n + n) % n;
      place(true);
      mark(announce);
      if (moveFocus) slides[active].focus({ preventScroll: true });
      restart();
    }
    track.addEventListener('transitionend', function (e) { if (e.target === track && e.propertyName === 'transform') normalise(); });

    /* autoplay with a pausable timer; the counter's progress line shows the time left */
    var timer = null, startedAt = 0, remaining = dur, hovering = false, focused = false, onScreen = true, settled = false;
    function paused() { return !settled || hovering || focused || !onScreen || document.hidden || track.classList.contains('is-dragging'); }
    function runBar(fresh) {
      if (!bar) return;
      if (fresh) { bar.classList.remove('is-running'); void bar.offsetWidth; }
      hero.style.setProperty('--hero-dur', (dur / 1000) + 's');
      bar.classList.add('is-running');
    }
    function schedule() {
      clearTimeout(timer); timer = null;
      if (!dur || n < 2) return;
      hero.classList.toggle('is-paused', paused());
      if (paused()) return;
      startedAt = performance.now();
      timer = setTimeout(function () { go(1, false); }, remaining);
    }
    function restart() { remaining = dur; if (settled) runBar(true); schedule(); }
    function pause() { if (timer) { clearTimeout(timer); timer = null; remaining = Math.max(300, remaining - (performance.now() - startedAt)); } hero.classList.add('is-paused'); }
    function resume() { if (!paused()) { hero.classList.remove('is-paused'); schedule(); } }
    hero.addEventListener('mouseenter', function () { if (canHover.matches) { hovering = true; pause(); } });
    hero.addEventListener('mouseleave', function () { if (hovering) { hovering = false; resume(); } });
    hero.addEventListener('focusin', function () { focused = true; pause(); });
    hero.addEventListener('focusout', function (e) { if (!hero.contains(e.relatedTarget)) { focused = false; resume(); } });
    document.addEventListener('visibilitychange', function () { if (document.hidden) pause(); else resume(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { onScreen = en[0].isIntersecting; if (onScreen) resume(); else pause(); }, { threshold: 0.25 }).observe(hero);

    var prev = $('[data-hero-prev]', hero), nxt = $('[data-hero-next]', hero);
    if (prev) prev.addEventListener('click', function () { go(-1, true); });
    if (nxt) nxt.addEventListener('click', function () { go(1, true); });
    hero.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); go(e.key === 'ArrowRight' ? 1 : -1, true); }
    });

    /* drag / swipe: the track follows the pointer, then settles on the nearest slide */
    var sx = null, sy = 0, dx = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (n < 2 || !e.isPrimary || (e.pointerType === 'mouse' && e.button !== 0)) return;
      normalise(); sx = e.clientX; sy = e.clientY; dx = 0; moved = false;
    });
    window.addEventListener('pointermove', function (e) {
      if (sx === null) return;
      dx = e.clientX - sx;
      if (!moved) {
        if (Math.abs(e.clientY - sy) > Math.abs(dx) && Math.abs(e.clientY - sy) > 8) { sx = null; return; }
        if (Math.abs(dx) < 6) return;
        moved = true; track.classList.add('is-dragging'); pause();
      }
      track.style.transform = 'translate3d(calc(' + (-pos * 100) + '% + ' + dx + 'px),0,0)';
    });
    function release() {
      if (sx === null) return;
      sx = null;
      if (!moved) return;
      track.classList.remove('is-dragging');
      var w = viewport.clientWidth || 1;
      if (Math.abs(dx) > Math.min(90, w * 0.18)) { hero.setAttribute('data-swiped', '1'); go(dx < 0 ? 1 : -1, true); }
      else { place(true); hero.setAttribute('data-swiped', '1'); resume(); }
    }
    window.addEventListener('pointerup', release);
    window.addEventListener('pointercancel', function () { if (sx !== null) { sx = null; if (moved) { track.classList.remove('is-dragging'); place(true); resume(); } } });
    hero.addEventListener('click', function (e) { if (hero.getAttribute('data-swiped')) { hero.removeAttribute('data-swiped'); e.preventDefault(); } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    place(false);
    mark(false);
    restart();
    desk.addEventListener('change', function () { mark(false); });
    window.addEventListener('resize', fitHeight);
    $$('img', track).forEach(function (i) { if (!i.complete) i.addEventListener('load', fitHeight, { once: true }); });
    /* after load + first interaction (or 6s): decode every banner so a slide never arrives half-painted, then start autoplay */
    afterSettle(function () {
      $$('img', track).forEach(function (i) { i.loading = 'eager'; if (i.decode) i.decode().then(fitHeight).catch(function () {}); });
      settled = true; fitHeight(); restart();
    }, 6000);
  })();

  /* ── Bestsellers: centred card, neighbours glide in a straight line — phones included.
        (2 Nov 2026: QA F24 had switched phones to two cards side by side; the client wants the centred slider back there too.) ── */
  (function () {
    var rail = document.getElementById('bestseller-rail'); if (!rail) return;
    var cards = $$('.product-card', rail), n = cards.length; if (n < 2) return;
    var bar = $('.rail-progress');
    var stage = document.createElement('div'); stage.className = 'orbit-stage';
    rail.parentNode.insertBefore(stage, rail); stage.appendChild(rail);
    rail.classList.add('is-orbit');
    rail.setAttribute('role', 'region'); rail.setAttribute('aria-roledescription', 'carousel'); rail.setAttribute('aria-label', 'Bestsellers');
    var controls = document.createElement('div'); controls.className = 'orbit-controls';
    controls.innerHTML = '<button class="icon-button round-button" type="button" aria-label="Previous product"><svg class="icon" aria-hidden="true"><use href="#i-chevron-left"/></svg></button>' +
      '<span class="orbit-count" aria-live="polite"><strong>01</strong> / ' + String(n).padStart(2, '0') + '</span>' +
      '<button class="icon-button round-button" type="button" aria-label="Next product"><svg class="icon" aria-hidden="true"><use href="#i-chevron-right"/></svg></button>';
    stage.parentNode.insertBefore(controls, bar || stage.nextSibling);
    if (bar) { bar.classList.add('is-orbit'); bar.parentNode.insertBefore(bar, controls.nextSibling); }
    var prevBtn = controls.children[0], nextBtn = controls.children[2], count = $('strong', controls);
    var active = 0;
    function geometry() { var w = window.innerWidth; if (w < 700) return { card: Math.min(280, Math.round(w * 0.64)), gap: 12 }; if (w < 1024) return { card: 300, gap: 20 }; return { card: 320, gap: 28 }; }
    function layout() {
      var g = geometry(), maxH = 0;
      rail.style.setProperty('--orbit-w', g.card + 'px');
      cards.forEach(function (c, i) {
        c.classList.remove('is-in');
        var d = i - active; if (d > n / 2) d -= n; if (d < -n / 2) d += n;
        var ad = Math.abs(d), sc = ad === 0 ? 1 : Math.max(.76, 1 - ad * .12);
        var x = Math.sign(d) * (ad === 0 ? 0 : g.card * (0.5 + sc / 2) + g.gap + (ad - 1) * (g.card * sc + g.gap));
        c.style.transform = 'translateX(' + x.toFixed(1) + 'px) scale(' + sc + ')';
        c.style.opacity = ad <= 1 ? 1 : ad === 2 ? .86 : 0; /* neighbours at full opacity (26 Oct: .96 dropped the button below contrast) */
        c.style.zIndex = String(20 - ad);
        c.style.pointerEvents = ad > 2 ? 'none' : '';
        c.classList.toggle('is-active', ad === 0);
        c.setAttribute('aria-hidden', ad === 0 ? 'false' : 'true');
        $$('a,button', c).forEach(function (el) { el.tabIndex = ad === 0 ? 0 : -1; });
      });
      cards.forEach(function (c) { maxH = Math.max(maxH, c.offsetHeight); });
      rail.style.setProperty('--orbit-h', (maxH + 36) + 'px');
      count.textContent = String(active + 1).padStart(2, '0');
      if (bar) { var sp = bar.firstElementChild; sp.style.width = (100 / n) + '%'; sp.style.transform = 'translateX(' + (active * 100) + '%)'; }
    }
    function go(i) { active = (i % n + n) % n; layout(); }
    prevBtn.addEventListener('click', function () { go(active - 1); });
    nextBtn.addEventListener('click', function () { go(active + 1); });
    rail.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(active + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(active - 1); } });
    rail.addEventListener('click', function (e) { var c = e.target.closest('.product-card'); if (c && !c.classList.contains('is-active') && !c.classList.contains('is-in')) { e.preventDefault(); e.stopPropagation(); go(cards.indexOf(c)); } }, true);
    var sx = null, sy = 0, moved = false;
    rail.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; moved = false; });
    rail.addEventListener('pointermove', function (e) { if (sx !== null && Math.abs(e.clientX - sx) > 8) moved = true; });
    window.addEventListener('pointerup', function (e) { if (sx === null) return; var dx = e.clientX - sx, dy = e.clientY - sy; sx = null; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(active + (dx < 0 ? 1 : -1)); });
    rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    window.addEventListener('resize', layout);
    window.addEventListener('load', layout);
    $$('img', rail).forEach(function (img) { if (!img.complete) img.addEventListener('load', layout, { once: true }); });
    layout();
  })();

  /* ── Shop by dish: auto-scroll the visitor can swipe, drag or scroll at any time ── */
  (function () {
    var grid = $('.dish-grid'); if (!grid) return;
    /* nothing is built until the section is near the viewport */
    if ('IntersectionObserver' in window) {
      var near = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { near.disconnect(); build(); } }, { rootMargin: '600px 0px' });
      near.observe(grid);
    } else build();
    function build() {
    var rail = document.createElement('div'); rail.className = 'dish-rail';
    rail.setAttribute('role', 'region'); rail.setAttribute('aria-label', 'Dishes. Swipe to explore');
    grid.parentNode.insertBefore(rail, grid); rail.appendChild(grid);
    var originals = Array.prototype.slice.call(grid.children); if (!originals.length) return;
    $$('img', grid).forEach(function (img) { img.draggable = false; });
    function addSet() { originals.forEach(function (li) { var c = li.cloneNode(true); c.setAttribute('aria-hidden', 'true'); $$('a,button', c).forEach(function (el) { el.tabIndex = -1; }); grid.appendChild(c); }); }
    var sets = 1; addSet(); sets++;
    while (grid.scrollWidth < rail.clientWidth * 3 || sets % 2) { addSet(); sets++; if (sets > 12) break; }
    var setWidth = function () { return grid.children[originals.length].offsetLeft - grid.children[0].offsetLeft; };
    var pos = setWidth(), last = 0, pausedUntil = 0, hovering = false, dragging = false;
    rail.scrollLeft = pos;
    function wrap() { var w = setWidth(); if (rail.scrollLeft >= w * 2) rail.scrollLeft -= w; else if (rail.scrollLeft <= 2) rail.scrollLeft += w; pos = rail.scrollLeft; }
    /* the frame loop only runs while the rail is on screen */
    var visible = true, looping = false;
    function frame(t) {
      if (!visible) { looping = false; last = 0; return; }
      var dt = last ? Math.min(t - last, 50) : 16; last = t;
      /* 2 Nov 2026 (client: "slider shi se chl nhi rhe"): 0.045px/ms was 0.75px a frame, and scrollLeft only moves in whole
         pixels, so every 4th frame stood still (1,1,1,0) and the rail juddered on phones. 0.06 = one whole pixel a 60Hz frame. */
      if (!hovering && !dragging && t > pausedUntil && !document.hidden) { pos += dt * 0.06; rail.scrollLeft = pos; if (Math.abs(rail.scrollLeft - pos) > 2) pos = rail.scrollLeft; }
      requestAnimationFrame(frame);
    }
    function loop() { if (!looping && visible) { looping = true; requestAnimationFrame(frame); } }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; loop(); }).observe(rail);
    loop();
    function hold(ms) { pausedUntil = performance.now() + (ms || 2500); }
    rail.addEventListener('scroll', function () { if (dragging || performance.now() < pausedUntil) wrap(); else if (rail.scrollLeft >= setWidth() * 2 || rail.scrollLeft <= 2) wrap(); }, { passive: true });
    rail.addEventListener('touchstart', function () { hold(4000); }, { passive: true });
    rail.addEventListener('touchmove', function () { hold(3000); }, { passive: true });
    rail.addEventListener('wheel', function () { hold(3000); }, { passive: true });
    rail.addEventListener('mouseenter', function () { hovering = true; });
    rail.addEventListener('mouseleave', function () { hovering = false; });
    rail.addEventListener('focusin', function () { hold(6000); });
    var startX = 0, startLeft = 0, movedPx = 0;
    rail.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; dragging = true; movedPx = 0; startX = e.clientX; startLeft = rail.scrollLeft; });
    window.addEventListener('pointermove', function (e) { if (!dragging) return; var dx = e.clientX - startX; movedPx = Math.max(movedPx, Math.abs(dx)); if (movedPx > 4) rail.classList.add('is-dragging'); rail.scrollLeft = startLeft - dx; });
    window.addEventListener('pointerup', function () { if (!dragging) return; dragging = false; hold(2000); pos = rail.scrollLeft; setTimeout(function () { rail.classList.remove('is-dragging'); }, 0); });
    window.addEventListener('resize', wrap);
    }
  })();

  /* ── Ready to cook: cinematic wipe between products ── */
  (function () {
    var sec = document.getElementById('ready-to-cook'); if (!sec) return;
    var slides = $$('.rtc-slide', sec); if (slides.length < 2) { var nav = $('.rtc-nav', sec); if (nav) nav.hidden = true; return; }
    var dots = $$('.rtc-nav__dot', sec), active = 0, busy = false;
    function a11y() {
      slides.forEach(function (s, i) { s.setAttribute('aria-hidden', i === active ? 'false' : 'true'); $$('a,button', s).forEach(function (el) { el.tabIndex = i === active ? 0 : -1; }); });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === active ? 'true' : 'false'); });
    }
    function go(next, dir) {
      next = (next + slides.length) % slides.length; if (next === active || busy) return;
      busy = true;
      var from = slides[active], to = slides[next];
      dir = dir || (next > active ? 1 : -1);
      sec.style.setProperty('--dir', dir); sec.style.setProperty('--wx', dir > 0 ? '78%' : '22%');
      from.classList.remove('is-active', 'is-entering'); from.classList.add('is-leaving');
      to.classList.remove('is-leaving'); void to.offsetWidth; to.classList.add('is-active', 'is-entering');
      active = next; a11y();
      setTimeout(function () { from.classList.remove('is-leaving'); busy = false; }, 1100);
      setTimeout(function () { to.classList.remove('is-entering'); }, 2300);
    }
    $('[data-rtc-prev]', sec).addEventListener('click', function () { go(active - 1, -1); });
    $('[data-rtc-next]', sec).addEventListener('click', function () { go(active + 1, 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    sec.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(active + 1, 1); if (e.key === 'ArrowLeft') go(active - 1, -1); });
    var sx = null, sy = 0, moved = false;
    sec.addEventListener('pointerdown', function (e) { if (e.button !== 0 && e.pointerType === 'mouse') return; sx = e.clientX; sy = e.clientY; moved = false; });
    window.addEventListener('pointermove', function (e) { if (sx !== null && Math.abs(e.clientX - sx) > 10) moved = true; });
    window.addEventListener('pointerup', function (e) { if (sx === null) return; var dx = e.clientX - sx, dy = e.clientY - sy; sx = null; if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) { sec.classList.add('was-swiped'); go(active + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1); } });
    sec.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    sec.addEventListener('dragstart', function (e) { e.preventDefault(); });
    a11y();
  })();

  /* ── Reviews: one auto-scrolling row, cards rendered by the section ── */
  (function () {
    var sec = $('.reviews-section'); if (!sec) return;
    var cards = $$('.review-card', sec); if (!cards.length) return;
    var rails = document.createElement('div'); rails.className = 'review-rails';
    rails.setAttribute('role', 'region'); rails.setAttribute('aria-label', 'Customer reviews');
    cards[0].parentNode.insertBefore(rails, cards[0]);
    var rail = document.createElement('div'); rail.className = 'review-rail';
    var track = document.createElement('div'); track.className = 'review-track';
    cards.forEach(function (c) { track.appendChild(c); });
    cards.forEach(function (c) { var copy = c.cloneNode(true); copy.setAttribute('aria-hidden', 'true'); $$('[role]', copy).forEach(function (el) { el.removeAttribute('role'); el.removeAttribute('aria-label'); }); track.appendChild(copy); });
    rail.appendChild(track); rails.appendChild(rail);
    sec.classList.add('has-rails');
  })();

  /* ── Natasha: hand-drawn arrow on view ── */
  (function () {
    var sec = $('.natasha-section'); if (!sec) return;
    sec.classList.add('arrow-armed');
    inView(sec, 0.35, function () { sec.classList.add('is-drawn'); });
  })();

  /* ── ZOFF Veda: ambient light, motes, steam, parallax, staged entrance, 3D tilt ── */
  (function () {
    var sec = document.getElementById('zoff-veda'); if (!sec) return;
    var amb = document.createElement('div'); amb.className = 'veda-ambient'; amb.setAttribute('aria-hidden', 'true');
    amb.innerHTML = '<span class="veda-blob veda-blob--sage"></span><span class="veda-blob veda-blob--gold"></span><span class="veda-blob veda-blob--blush"></span>';
    var colours = ['#c9a44a', '#8fa876', '#b5733d', '#e0c77a', '#7c9464'];
    for (var i = 0; i < 16; i++) {
      var m = document.createElement('span'); m.className = 'veda-mote';
      m.style.cssText = 'left:' + (Math.random() * 100).toFixed(1) + '%;--s:' + (3 + Math.random() * 5).toFixed(1) + 'px;--c:' + colours[i % colours.length] +
        ';--t:' + (9 + Math.random() * 9).toFixed(1) + 's;--d:-' + (Math.random() * 14).toFixed(1) + 's;--dx:' + (Math.random() * 60 - 30).toFixed(0) + 'px;--o:' + (.35 + Math.random() * .4).toFixed(2);
      amb.appendChild(m);
    }
    sec.insertBefore(amb, sec.firstChild);
    var cup = $('.veda-hero', sec);
    if (cup) {
      var wrap = document.createElement('div'); wrap.className = 'veda-hero-wrap';
      cup.parentNode.insertBefore(wrap, cup);
      wrap.innerHTML = '<span class="veda-sun" aria-hidden="true"></span>';
      wrap.appendChild(cup);
      wrap.insertAdjacentHTML('beforeend', '<svg class="veda-steam" viewBox="0 0 60 80" aria-hidden="true"><path d="M18 78c-8-12 8-18 0-30s8-20 0-34"/><path d="M32 78c-8-12 8-18 0-30s8-20 0-34"/><path d="M46 78c-8-12 8-18 0-30s8-20 0-34"/></svg>');
    }
    sec.classList.add('veda-armed');
    inView(sec, 0.2, function () { sec.classList.add('is-in'); });
    var ticking = false;
    function parallax() { var r = sec.getBoundingClientRect(), vh = window.innerHeight; var p = ((r.top + r.height / 2) - vh / 2) / vh; sec.style.setProperty('--vp', Math.max(-1.2, Math.min(1.2, p)).toFixed(3)); ticking = false; }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(parallax); } }, { passive: true });
    parallax();
    $$('.veda-card', sec).forEach(function (card) {
      card.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'touch') return;
        var r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        card.style.setProperty('--ry', ((x - .5) * 12).toFixed(2) + 'deg'); card.style.setProperty('--rx', ((.5 - y) * 10).toFixed(2) + 'deg');
        card.style.setProperty('--mx', (x * 100).toFixed(1) + '%'); card.style.setProperty('--my', (y * 100).toFixed(1) + '%');
        card.classList.add('is-tilting');
      });
      card.addEventListener('pointerleave', function () { card.classList.remove('is-tilting'); card.style.setProperty('--rx', '0deg'); card.style.setProperty('--ry', '0deg'); });
      card.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') { card.classList.add('is-tilting'); setTimeout(function () { card.classList.remove('is-tilting'); }, 380); } });
    });
    /* cards/CTA without a link open the "More ZOFF" dialog, as in the design */
    $$('[data-brand]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        var dlg = document.getElementById('brand-dialog'), tpl = document.getElementById('veda-content');
        if (!dlg || !tpl || !window.ZH) return;
        $('#brand-dialog-body').innerHTML = ''; $('#brand-dialog-body').appendChild(tpl.content.cloneNode(true));
        window.ZH.open('brand-dialog', b);
      });
    });
  })();

  /* ── Academy: rotating "today's guide" ticker ── */
  (function () {
    var box = $('.acad-banner'); if (!box) return;
    var items = $$('.acad-lesson', box), dots = $$('.acad-dots button', box);
    if (!items.length) return;
    var i = 0, timer = null, DUR = 4500;
    function sync() {
      items.forEach(function (el, n) { el.setAttribute('aria-hidden', n === i ? 'false' : 'true'); el.tabIndex = n === i ? 0 : -1; });
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); d.classList.toggle('is-done', n < i); });
      var cur = dots[i]; if (cur) { cur.style.animation = 'none'; void cur.offsetWidth; cur.style.animation = ''; }
    }
    function go(n) {
      n = (n + items.length) % items.length; if (n === i) return;
      var from = items[i], to = items[n];
      from.classList.remove('is-active'); from.classList.add('is-leaving');
      setTimeout(function () { from.classList.remove('is-leaving'); }, 400);
      to.classList.add('is-active'); i = n; sync(); schedule();
    }
    function schedule() { clearTimeout(timer); if (box.classList.contains('is-auto') && !box.classList.contains('is-paused')) timer = setTimeout(function () { go(i + 1); }, DUR); }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    box.addEventListener('mouseenter', function () { box.classList.add('is-paused'); clearTimeout(timer); });
    box.addEventListener('mouseleave', function () { box.classList.remove('is-paused'); sync(); schedule(); });
    box.addEventListener('focusin', function () { box.classList.add('is-paused'); clearTimeout(timer); });
    box.addEventListener('focusout', function () { box.classList.remove('is-paused'); schedule(); });
    sync();
    inView(box, 0.4, function () { box.classList.add('is-auto'); sync(); schedule(); });
  })();

  /* ── Closing CTA: copy fades up on view ── */
  (function () {
    var card = $('.cta-card'); if (!card) return;
    card.classList.add('cta-armed');
    inView(card, 0.35, function () { card.classList.add('is-in'); });
  })();

  /* ── Video dialog: fetched only after a deliberate click, never during page load ── */
  (function () {
    var dlg = document.getElementById('video-dialog'); if (!dlg) return;
    var mount = $('#video-mount'), fallback = $('#video-fallback'), extWrap = $('#video-external-wrap'), ext = $('#video-external');
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-video]'); if (!btn || !window.ZH) return;
      var source = btn.getAttribute('data-video-url') || '', title = btn.getAttribute('data-video-title') || 'Inside ZOFF';
      $('#video-title').textContent = title;
      mount.innerHTML = '';
      fallback.hidden = !!source; extWrap.hidden = !source;
      if (source) {
        var url = null; try { url = new URL(source); } catch (_) {}
        if (url && url.protocol === 'https:') {
          ext.href = source;
          if (/\.(mp4|webm|ogg)$/i.test(url.pathname) || /cdn\.shopify|shopify\.com\/videos/.test(url.hostname + url.pathname)) {
            mount.innerHTML = '<video src="' + esc(source) + '" controls autoplay playsinline preload="metadata" aria-label="' + esc(title) + '"></video>';
          } else if (['www.youtube.com', 'youtube.com', 'youtu.be', 'www.youtube-nocookie.com', 'm.youtube.com'].indexOf(url.hostname) > -1) {
            var id = url.hostname === 'youtu.be' ? url.pathname.slice(1) : url.searchParams.get('v') || url.pathname.split('/').pop();
            if (/^[A-Za-z0-9_-]{11}$/.test(id || '')) mount.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0" title="' + esc(title) + '" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen referrerpolicy="strict-origin-when-cross-origin"></iframe>';
          }
        }
      }
      window.ZH.open('video-dialog', btn);
    });
  })();
})();
